import * as React from "react";
import type { SVGProps } from "react";
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.02622 13.9987C12.7929 13.9987 15.8464 11.1632 15.8464 7.66536C15.8464 4.16756 12.7929 1.33203 9.02622 1.33203C5.25955 1.33203 2.20605 4.16756 2.20605 7.66536C2.20605 11.1632 5.25955 13.9987 9.02622 13.9987Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5647 14.6654L15.1289 13.332"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgSearch;
